import { createApp } from 'vue'
import AdvancedRadio from './AdvancedRadio'

const el = '.kb-component--advanced-radio'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((AdvancedRadioDOM) => {
            const props = {
                type: AdvancedRadioDOM.dataset.type,
                tooltipText: AdvancedRadioDOM.dataset.tooltiptext,
                errorMessageLabel: AdvancedRadioDOM.dataset.errormessagelabel,
                helpMessageLabel: AdvancedRadioDOM.dataset.helpmessagelabel,
                placeholder: AdvancedRadioDOM.dataset.placeholder,
                label: AdvancedRadioDOM.dataset.label,
                legend: AdvancedRadioDOM.dataset.legend,
                isRequired: !!(AdvancedRadioDOM.dataset.isrequired === 'true'),
                fieldName: AdvancedRadioDOM.dataset.fieldname,
                radioOptions: JSON.parse(AdvancedRadioDOM.dataset.radiooptions)
            }
            const component = createApp(AdvancedRadio, props).use(Store)
            component.mount(AdvancedRadioDOM)
        })
    }
}
